import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import FormControl from "@mui/material/FormControl";

export default function LinkItemExtraFields({ formData, setFormData }) {
  return (
    <>
      <Grid size={12}>
        <TextField
          fullWidth
          required
          label="Link"
          type="url"
          variant="standard"
          value={formData.item_metadata.url || ""}
          onChange={(event) =>
            setFormData((formData) => {
              formData.item_metadata.url = event.target.value;
              return { ...formData };
            })
          }
        />
      </Grid>
      <Grid size={12}>
        <FormControl
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={formData.item_metadata?.new_tab || false}
                onChange={(event, checked) => {
                  setFormData((formData) => {
                    formData.item_metadata.new_tab = checked;
                    return { ...formData };
                  });
                }}
                color="secondary"
              />
            }
            label="Open in new tab"
          />
        </FormControl>
      </Grid>
    </>
  );
}
